var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhXLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ph:x-light"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M23.9344 22.9407C24.0035 23.005 24.0589 23.0827 24.0973 23.1689C24.1358 23.2552 24.1564 23.3483 24.1581 23.4427C24.1598 23.5371 24.1424 23.6309 24.107 23.7184C24.0717 23.806 24.019 23.8855 23.9523 23.9523C23.8855 24.019 23.806 24.0717 23.7184 24.107C23.6309 24.1424 23.5371 24.1598 23.4427 24.1581C23.3483 24.1564 23.2552 24.1358 23.1689 24.0973C23.0827 24.0589 23.005 24.0035 22.9407 23.9344L15 15.995L7.05941 23.9344C6.92613 24.0586 6.74983 24.1262 6.56767 24.123C6.38552 24.1198 6.21172 24.046 6.08289 23.9172C5.95407 23.7884 5.88028 23.6146 5.87706 23.4324C5.87385 23.2502 5.94146 23.074 6.06566 22.9407L14.0051 15L6.06566 7.05941C5.94146 6.92613 5.87385 6.74983 5.87706 6.56767C5.88028 6.38552 5.95407 6.21172 6.08289 6.08289C6.21172 5.95407 6.38552 5.88028 6.56767 5.87706C6.74983 5.87385 6.92613 5.94146 7.05941 6.06566L15 14.0051L22.9407 6.06566C23.074 5.94146 23.2502 5.87385 23.4324 5.87706C23.6146 5.88028 23.7884 5.95407 23.9172 6.08289C24.046 6.21172 24.1198 6.38552 24.123 6.56767C24.1262 6.74983 24.0586 6.92613 23.9344 7.05941L15.995 15L23.9344 22.9407Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhXLight);
export default __webpack_public_path__ + "static/media/ph_x-light.810fb5f5ed89f135130e4f9ca4a4fad3.svg";
export { ForwardRef as ReactComponent };